module.exports = __webpack_public_path__ + "static/media/ClorinadorFlotante.b6ae15ac.jpg";